//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WGS84Service from '../../../services/wgs84ProjectionService';
import DetailMixin from './detailMixin';
import overviewEditMixin from './overviewEditMixin';
import SocketMixin from './socketMixin';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import get from 'lodash/get';
import { getMapOverlayData } from '../../../utils/geoMapOverlayInfo';
export default {
  name: 'CoreDtwinDetail',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [SocketMixin, overviewEditMixin, DetailMixin],
  props: {
    mapmode: {
      type: Boolean,
      required: false,
      default: false
    },
    hideItems: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    dtwinOverlayInfo: function dtwinOverlayInfo() {
      return getMapOverlayData(get(this.dtwin, 'data.indoor'));
    },
    showMap: function showMap() {
      if (this.mapmode) {
        return false;
      }

      if (get(this.dtwin, 'data.twinImagePreferOverMap') && get(this.dtwin, 'data.twinImageId')) {
        return false;
      }

      var coordinates = get(this.dtwin, 'coordinates.coordinates', [null, null]);
      var coordinate = {
        lat: coordinates[1],
        lon: coordinates[0]
      };
      return WGS84Service.isValidWgs84(coordinate);
    },
    headerBG: function headerBG() {
      if (get(this.dtwin, 'data.twinImageId')) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(this.dtwin.data.twinImageId);
      }

      return null;
    },
    showSkeletonLoader: function showSkeletonLoader() {
      return get(this.dtwin, 'data', true) === true;
    },
    dtwinCoordinates: function dtwinCoordinates() {
      return get(this.dtwin, 'coordinates.coordinates', [null, null]);
    },
    dtwinPolygon: function dtwinPolygon() {
      return get(this.dtwin, 'polygon.coordinates', []);
    },
    detailButtonIcon: function detailButtonIcon() {
      return this.twinCanBeEdited(this.dtwin) ? 'fa-edit' : 'fa-eye';
    },
    detailButtonTitle: function detailButtonTitle() {
      return this.twinCanBeEdited(this.dtwin) ? this.$i18n_t('Common.edit') : this.$i18n_t('DigitalTwin.DigitalTwin.viewDetails');
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    parallaxHeight: function parallaxHeight() {
      return this.mapmode ? 130 : 200;
    },
    descriptionHeight: function descriptionHeight() {
      return "max-height: ".concat(this.mapmode ? 100 : 250, "px; overflow: auto;");
    },
    showDetilsIdTrans: function showDetilsIdTrans() {
      return this.baseLink === 'digitaltwin-mgmt' ? this.$i18n_t('Common.twinId') : this.$i18n_t('Common.virtualId');
    },
    hasDependentDevices: function hasDependentDevices() {
      return this.twinDependencies && this.twinDependencies.virtualDevices && this.twinDependencies.virtualDevices.length > 0;
    }
  },
  watch: {},
  methods: {
    get: get
  }
};